"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabularFilter = void 0;
class TabularFilter {
    constructor(filter) {
        this.column = (filter === null || filter === void 0 ? void 0 : filter.column) || { id: '', label: '' };
        this.type = (filter === null || filter === void 0 ? void 0 : filter.type) || 'starts_with';
        this.key = (filter === null || filter === void 0 ? void 0 : filter.key) || '';
        this.id = (filter === null || filter === void 0 ? void 0 : filter.id) || -1;
    }
}
exports.TabularFilter = TabularFilter;
